import { render, staticRenderFns } from "./dsa.vue?vue&type=template&id=99704b5e&scoped=true&"
import script from "./dsa.vue?vue&type=script&lang=js&"
export * from "./dsa.vue?vue&type=script&lang=js&"
import style0 from "./dsa.vue?vue&type=style&index=0&id=99704b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99704b5e",
  null
  
)

export default component.exports